import { MenuProps } from "antd";
import Menu from "./Menu";
import { AppstoreOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';
import { getIconForKey } from "./IconMap";

type MenuItem = Required<MenuProps>['items'][number];
export default class CustumMenu {
    label: React.ReactNode;
    key: React.Key | null;
    icon?: React.ReactNode;
    children?: MenuItem[];
    type?: 'group';

    constructor(label: React.ReactNode, key: React.Key, icon: string, children?: Array<MenuItem>){
        this.label = label;
        this.key = key;
        this.icon = getIconForKey(icon);
        this.children = children;
    }

    // Provisoirement
    static getMenu(menus : Array<Menu>) : Array<MenuItem>{
        var custumMenu : Array<CustumMenu> = []
        
        var lepere1 : string = ""
        var niveau = 1;

        //Menu "⚫ .."
        menus.forEach((menu : Menu) => {
            if(menu.codmen.length == 1 && menu.libelmenfr != "-" ){
                //alert(menu.icon)
                if(menu.lien+"" == ""){
                    lepere1 = menu.codmen.substring(0,niveau)
                    custumMenu.push(new CustumMenu(menu.libelmenfr.replace("&", ""), menu.codmen, menu.icon ||"", CustumMenu.sousMenu(menus, lepere1, niveau+2) as MenuItem[]))    
                }else{
                    custumMenu.push(new CustumMenu(menu.libelmenfr.replace("&", ""), menu.codmen, menu.icon ||""))
                }
            }
        });

        return custumMenu as MenuItem[];
    }
    private static sousMenu(menus : Array<Menu>, lepere: string, niveau: number): CustumMenu[]{
        var custumMenu : Array<CustumMenu> = []
        var lepere2 : string = ""
        //"◾ .."   
        menus.forEach((menu : Menu) => {
            if(menu.codmen.length == niveau && menu.codmen.substring(0,niveau-2) == lepere && menu.libelmenfr != "-" ){
                if(menu.lien+"" == ""){
                    lepere2 = menu.codmen.substring(0,niveau)
                    custumMenu.push(new CustumMenu(menu.libelmenfr.replace("&", ""), menu.codmen, menu.icon||"", CustumMenu.sousMenu2(menus, lepere2, niveau+2) as MenuItem[]))
                }else{
                    custumMenu.push(new CustumMenu(menu.libelmenfr.replace("&", ""), menu.codmen, menu.icon ||""))
                }
            }

        });
        return custumMenu;
    }
    private static sousMenu2(menus : Array<Menu>, lepere: string, niveau: number): CustumMenu[]{
        var custumMenu : Array<CustumMenu> = []
        var lepere3 : string = ""

        menus.forEach((menu : Menu) => {
            if(menu.codmen.length == niveau && menu.codmen.substring(0,niveau-2) == lepere && menu.libelmenfr != "-" ){
                if(menu.lien+"" == ""){
                    lepere3 = menu.codmen.substring(0,niveau)
                    custumMenu.push(new CustumMenu(menu.libelmenfr.replace("&", ""), menu.codmen, menu.icon ||"", CustumMenu.sousMenu3(menus, lepere3, niveau+2) as MenuItem[]))
                }else{
                    custumMenu.push(new CustumMenu(menu.libelmenfr.replace("&", ""), menu.codmen, menu.icon ||""))
                }
            }

        });
        return custumMenu;
    }
    
    private static sousMenu3(menus : Array<Menu>, lepere: string, niveau: number): CustumMenu[]{
        var custumMenu : Array<CustumMenu> = []

        menus.forEach((menu : Menu) => {
            if(menu.codmen.length == niveau && menu.codmen.substring(0,niveau-2) == lepere && menu.libelmenfr != "-" ){
                
                custumMenu.push(new CustumMenu(menu.libelmenfr.replace("&", ""), menu.codmen, menu.icon ||""))
            }

        });
        return custumMenu;
    }
}